export default __webpack_public_path__ + "psn-chat.8df005d7e357efb79b8dc043b0d9896b.css";